/**
 * @file The typed rejection `uploadAttachments` raises when at least one file in
 * a batch did not upload. Thrown by `useAttachmentUpload`, recognised by
 * `useAttachments`, which declines to toast it.
 * Invariant: every failure inside it is already on its own transfer row with a
 * Retry, so the reader has been told where they can act. A toast on top would
 * repeat that and name a file they would then have to go find. The message is
 * written for the log, not the screen — it carries each file's own reason so a
 * console trace still says which file failed and why.
 */

class AttachmentUploadBatchError extends Error {
  /** One entry per file that did not upload, each already shown on its row. */
  readonly failures: readonly string[];

  constructor(failures: readonly string[], attemptedCount: number) {
    super(`${failures.length} of ${attemptedCount} file(s) did not upload: ${failures.join('; ')}`);
    this.name = 'AttachmentUploadBatchError';
    this.failures = failures;
  }
}

export { AttachmentUploadBatchError };
